const e=e=>{const r=(null==e?void 0:e.reference)?` - ${null==e?void 0:e.reference}`:"";return`${null==e?void 0:e.title}${r}`.replace(/\s\s+/g," ").trim()};export{e as getFullTitle};
